import { List, Map, Record } from "immutable";

import {
  SemanticCategory,
  SubjectGroup,
  TAG_TYPES
} from "@seneca/tags-service-consts";

export type TagType = {
  id?: string;
  parentId?: string;
  text?: string;
  type?: typeof TAG_TYPES.tag;
  categoryIds: List<string>;
  details: Map<string, string>;
  semanticCategory?: SemanticCategory;
  subjectGroup?: SubjectGroup;
  coursesFilterOnly?: boolean;
};

export type TagFromServerType = TagType & {
  type: typeof TAG_TYPES.tag;
  categoryIds: Array<string>;
  details: any;
};

export type OptionalTagType = Partial<TagType>;

const defaultTag: TagType = {
  id: undefined,
  parentId: undefined,
  text: undefined,
  type: undefined,
  categoryIds: List(),
  details: Map<string, string>(),
  semanticCategory: undefined,
  subjectGroup: undefined,
  coursesFilterOnly: undefined
};

export default class Tag extends Record(defaultTag) {}
